import { isCanvas } from '@common/utils';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { IconButton as RNIconButton } from 'react-native-paper';
import { JPYCtransferForm } from './components/JPYCtransferForm';
import { CHAIN_IDS, JPYCTransferProps } from './type';
import { useJpycBindingValue } from './useBindingValue.hook';

const JPYCTransfer: React.FC<JPYCTransferProps> = (props) => {
  const _isCanvas = isCanvas();
  const bindingValue = useJpycBindingValue(props);
  const titleText = get(bindingValue, 'title.text', 'お支払い金額');
  const paymentButtonText = get(bindingValue, 'paymentButton.text', '次へ');
  const amount = get(bindingValue, 'amount', 0);
  const recipientAddress = get(bindingValue, 'recipientAddress') || '';

  const chainOptions = useMemo(
    () => [
      { value: CHAIN_IDS.POLYGON, label: 'Polygon' },
      { value: CHAIN_IDS.ETHEREUM, label: 'Ethereum' },
      { value: CHAIN_IDS.AVALANCHE, label: 'Avalanche' },
    ],
    []
  );
  if (_isCanvas) {
    const selectedChainId = CHAIN_IDS.POLYGON;
    return (
      <div
        style={{
          padding: 20,
          borderRadius: 12,
          boxShadow: '0 4px 10px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.06)',
          backgroundColor: '#ffffff',
          color: '#111827',
          width: '100%',
          height: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 28,
              backgroundColor: '#1e6fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#ffffff',
            }}
          >
            <RNIconButton icon="wallet" onPress={() => {}} color="#ffffff" />
          </div>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 20, fontWeight: 700 }}>{titleText}</div>
          <div style={{ color: '#6b7280', marginTop: 6, fontSize: 12 }}>
            支払い期限：YYYY/MM/DD HH:mm
          </div>
        </div>

        <div style={{ textAlign: 'center', margin: '12px 0 20px' }}>
          <span
            style={{
              fontSize: 48,
              fontWeight: 800,
              lineHeight: 1,
            }}
          >
            123,456
          </span>
          <span style={{ marginLeft: 8, fontSize: 20, fontWeight: 700 }}>
            JPYC
          </span>
        </div>

        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6 }}>
            ネットワーク
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              padding: '8px 12px',
            }}
          >
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: '#8247e5', // Polygon purple as default dot
                marginRight: 8,
              }}
            />
            <select
              value={selectedChainId}
              style={{
                flex: 1,
                border: 'none',
                outline: 'none',
                fontSize: 14,
                background: 'transparent',
                color: '#111827',
                WebkitAppearance: 'none' as any,
              }}
            >
              {chainOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6 }}>
            送信先アドレス
          </div>
          <div
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              padding: 12,
              fontSize: 13,
              color: '#374151',
              wordBreak: 'break-all',
              backgroundColor: '#f9fafb',
              lineHeight: 1.4,
              overflow: 'clip',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {recipientAddress || '0x------------------'}
          </div>
        </div>

        <button
          type="button"
          style={{
            width: '100%',
            height: 44,
            borderRadius: 24,
            border: 'none',
            backgroundColor: '#1e6fff',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: 16,
            cursor: 'pointer',
          }}
        >
          {paymentButtonText}
        </button>
      </div>
    );
  }
  return <JPYCtransferForm {...props} />;
  // return <div>JPYCTransfer</div>;
};
export default JPYCTransfer;
